import { PaletteOptions } from "@mui/material/styles";

import { ColorMode, tokens } from "./tokens";

/**
 * MUI palette for one colour mode, built from the design tokens.
 * Besides the standard keys it carries `status` (ok/info/warn/err/neutral fg/bg/line),
 * `brandTint` and `env` — see theme/augment.d.ts for their types.
 */
export function buildPalette(mode: ColorMode): PaletteOptions {
  const t = tokens[mode];
  const brand = {
    main: t.brand,
    dark: t.brandDark,
    light: t.brandTint,
    contrastText: t.brandContrast,
  };

  return {
    mode,
    primary: brand,
    secondary: { ...brand },
    error: { main: t.status.err.fg },
    warning: { main: t.status.warn.fg },
    success: { main: t.status.ok.fg },
    info: { main: t.status.info.fg },
    background: { default: t.page, paper: t.card },
    text: {
      primary: t.text.primary,
      secondary: t.text.secondary,
      disabled: t.text.disabled,
    },
    divider: t.border,
    grey: { 50: t.grey50, 100: t.grey100, 200: t.grey200 },
    status: t.status,
    brandTint: t.brandTint,
    env: t.env,
  };
}

export default buildPalette;
